import FaqListContainer from '../../containers/admin/FaqListContainer';

export default function FaqPage() {
    return (
        <FaqListContainer />
    );
}
